import { Link } from "react-router-dom";
import { Phone, MessageCircle, MapPin, Clock } from "lucide-react";
import { Logo } from "@/components/Logo";
import { BRAND, CATEGORIES, waLink } from "@/data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-ink text-cream pb-28 md:pb-0">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-20 pb-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        <div>
          <Logo dark />
          <p className="mt-6 text-sm leading-relaxed text-cream/60 max-w-xs">
            A sanctuary of stillness in Manikonda, Hyderabad. Seventeen signature services across
            massages, wraps, facials and private hydrotherapy.
          </p>
        </div>
        <div>
          <h3 className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Explore</h3>
          <ul className="space-y-3 text-sm">
            {[
              ["Home", "/"],
              ["All Services", "/services"],
              ["Membership", "/membership"],
              ["About Us", "/about"],
              ["Reviews", "/reviews"],
              ["FAQ", "/faq"],
              ["Contact", "/contact"],
            ].map(([label, to]) => (
              <li key={to}>
                <Link
                  to={to}
                  data-testid={`footer-link-${label.toLowerCase().replace(/\s/g, "-")}`}
                  className="text-cream/70 hover:text-gold transition-colors duration-300"
                >
                  {label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Services</h3>
          <ul className="space-y-3 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.slug}>
                <Link
                  to={`/services/${c.slug}`}
                  data-testid={`footer-cat-${c.slug}`}
                  className="text-cream/70 hover:text-gold transition-colors duration-300"
                >
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h3 className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Visit Us</h3>
          <address className="not-italic text-sm text-cream/70 leading-relaxed">
            {BRAND.address}
          </address>
          <div className="mt-5 space-y-3 text-sm">
            <a
              href={BRAND.tel}
              data-testid="footer-phone"
              className="flex items-center gap-2.5 text-cream/80 hover:text-gold transition-colors duration-300"
            >
              <Phone size={14} className="text-gold" /> {BRAND.phoneDisplay}
            </a>
            <a
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp"
              className="flex items-center gap-2.5 text-cream/80 hover:text-gold transition-colors duration-300"
            >
              <MessageCircle size={14} className="text-gold" /> WhatsApp Us
            </a>
            <a
              href={BRAND.maps}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-directions"
              className="flex items-center gap-2.5 text-cream/80 hover:text-gold transition-colors duration-300"
            >
              <MapPin size={14} className="text-gold" /> Get Directions
            </a>
            <p className="flex items-center gap-2.5 text-cream/60">
              <Clock size={14} className="text-gold" /> Open all days — call for timings
            </p>
          </div>
        </div>
      </div>
      <div className="gold-rule mt-14" />
      <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-cream/40 tracking-wide">
        <p>© {new Date().getFullYear()} Ody Luxurious Spa, Manikonda. All rights reserved.</p>
        <span>
          Design &amp; Developed by{" "}
          <a
            href="https://hubwalt.com/"
            target="_blank"
            rel="noreferrer"
            className="footer-credit"
            data-testid="footer-hubwalt-link"
          >
            Hubwalt
          </a>
        </span>
        <p className="uppercase tracking-[0.25em]">Stillness, perfected</p>
      </div>
    </div>
  </footer>
);
